import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const OneLoginCallback = () => {
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const authorizationCode = searchParams.get("code");

    if (authorizationCode) {
      // Call the backend endpoint to exchange the authorization code for an access token
      fetch("http://localhost:3000/oauth/token", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          code: authorizationCode,
          redirect_uri: "http://localhost:3000/onelogin/callback", // Ensure this matches your OAuth2 provider configuration
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Access Token:", data.access_token);
          // Store the access token securely
        })
        .catch((error) => {
          console.error("Error exchanging authorization code:", error);
        });
    }
  }, [location]);

  return <div>Authorizing...</div>;
};

export default OneLoginCallback;